export default "__VITE_ASSET__BKRR8TDC__"